export default __webpack_public_path__ + "static/aircrew-4f71ff89bacb04b797ac9f5528c6b238.png";